import type { AuthenticationService } from './mx-authentication-service';
import type { IRequestConfig, auto, IHttpResponse, IHttpInterceptor } from 'angular';
import type { UserWorkspaceService } from '../Shell/PandoraSolutionBuilderAgent/services/user-workspace-service';

authorizationInterceptor.$inject = ['$injector'];
export function authorizationInterceptor($injector: auto.IInjectorService): IHttpInterceptor {
	return {
		responseError: async function (response: IHttpResponse<unknown>) {
			const authService: AuthenticationService = $injector.get('mx.shell.AuthService');

			if (response.status === 401 || response.status === 406) {
				await authService.logout();
			}
			return Promise.reject(response);
		},

		request: async function (config: IRequestConfig) {
			const authService: AuthenticationService = $injector.get('mx.shell.AuthService');
			await authService.checkForTokenExpirationAndRefresh();
			const token = await authService.getToken();
			if (token) {
				config.headers ||= {};
				config.headers.Authorization = config.headers.Authorization || `Bearer ${token}`;
				try {
					const userWorkspaceService: UserWorkspaceService = $injector.get('mx.SolutionBuilderAgent.UserWorkspaceService');
					if (userWorkspaceService.currentUserWorkspaceId && userWorkspaceService.supportsCurrentApp() && !userWorkspaceService.ignoreWorkspace) {
						config.headers['mx-user-current-workspace'] = userWorkspaceService.currentUserWorkspaceId;
					}
				} catch (e) {
					//do nothing
				}
			}
			return config;
		},
	};
}
